<template>
  <transition name="fade">
    <div v-if="visible" :class="['overlay', status]">
      <div class="content">
        <h1>{{ statusText }}</h1>
        <h2>{{ employeeName }}</h2>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ClockStatusOverlay",
  props: {
    visible: Boolean,
    employeeName: String,
    status: String, // 'in' or 'out'
  },
  computed: {
    statusText() {
      return this.status === "in" ? "CLOCKED IN" : "CLOCKED OUT";
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  animation: pop 0.3s ease-out;
}

.overlay.in {
  background: rgba(0, 150, 0, 0.90); /* Green */
}

.overlay.out {
  background: rgba(200, 0, 0, 0.90); /* Red */
}

.content {
  text-align: center;
}

.content h1 {
  font-size: 60px;
  font-weight: bold;
  margin-bottom: 20px;
}

.content h2 {
  font-size: 40px;
  font-weight: 600;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes pop {
  0% { transform: scale(0.8); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
</style>